import { BsFillPlayCircleFill } from 'react-icons/bs';
import { millisToMinutesAndSeconds } from '@wajeez-web/core/utils';
export interface ContentItemCardProps {
  img?: string;
  title?: string;
  time?: number;
  isLocked?: boolean;
  onClick: () => void;
}

export const ContentItemCard = ({
  img = '',
  title = '',
  time = 0,
  isLocked,
  onClick,
}: ContentItemCardProps) => {
  return (
    <div
      onClick={onClick}
      className="relative bg-[#F2F3F5] my-2 space-y-[8px] px-5 py-4 rounded-[10px] cursor-pointer shadow-md"
    >
      {isLocked && (
        <div className="absolute left-[25px] bottom-[44px] w-[50px] h-[50px]">
          <img
            src="/assets/icons/premium-desktop.png"
            alt="premium-wajeez"
            className="w-full h-full"
          />
        </div>
      )}
      <div className=" flex items-center space-s-6">
        <img src={img} className="w-[97px] h-[92px]  rounded-[10px]" alt="" />
        <div className="text-[#27160E] text-xl font-bold">{title}</div>
      </div>
      <div className="flex space-s-2">
        <BsFillPlayCircleFill className="text-primary h-[25px] w-[24px]" />
        <div className="text-[#666666] text-[17px] font-medium">
          {millisToMinutesAndSeconds(time).split(':')[0] +
            ' دقيقة' +
            ' و ' +
            millisToMinutesAndSeconds(time).split(':')[1] +
            ' ثانية'}
        </div>
      </div>
    </div>
  );
};
